const originalFetch = require('isomorphic-fetch');
const fetchRetry = require('fetch-retry')(originalFetch);

export default fetchRetry;
